var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m300 557.14h-0.60156c-23.664 0-42.863 19.164-42.863 42.863s19.164 42.863 42.863 42.863h0.63672 599.93 0.60156c23.664 0 42.863-19.164 42.863-42.863s-19.164-42.863-42.863-42.863h-0.63672z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m642.86 300v-0.60156c0-23.664-19.164-42.863-42.863-42.863s-42.863 19.164-42.863 42.863v0.63672-0.039062 599.96 0.60156c0 23.664 19.164 42.863 42.863 42.863s42.863-19.164 42.863-42.863v-0.63672 0.039063z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600 0c-330.86 0-599.96 269.14-599.96 599.96 0 330.82 269.14 599.96 599.96 599.96 330.86 0 599.96-269.14 599.96-599.96 0-330.82-269.14-599.96-599.96-599.96zm0 85.727c284.55 0 514.27 229.76 514.27 514.27s-229.73 514.27-514.27 514.27c-284.55 0-514.27-229.73-514.27-514.27 0-284.55 229.73-514.27 514.27-514.27z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.dbc9214b515f1661202220453f07dd5b.svg";
export { ForwardRef as ReactComponent };